<div class="content-container">
        <zui-sidenav
            #sidenav
            [sidenavParams]="sidenavConfig"
            [header]="sidenavHeader"
            [footer]="sidenavFooter"
            [hideSidenav]="isPxLogin$ | async"
            (emitSelectedCompany)="selectCompany($event)"
        >
            <zui-progress-spinner
                    id="app-loading"
                    *ngIf="isLoading$ | async"
                    class="progress-spinner"
                    color="accent"
                    diameter=256
            ></zui-progress-spinner>
            <router-outlet></router-outlet>
        </zui-sidenav>
    <zui-footer-component></zui-footer-component>
</div>
